import { createFileRoute } from "@tanstack/react-router";
import { ContentPage, isContentTab, type ContentTab } from "@/components/admin/content/ContentPage";

export const Route = createFileRoute("/dashboard/admin/content/")({
  validateSearch: (search: Record<string, unknown>): { tab?: ContentTab } =>
    isContentTab(search.tab) ? { tab: search.tab } : {},
  component: ContentRoute,
});

function ContentRoute() {
  const { tab } = Route.useSearch();
  return <ContentPage tab={tab ?? "pages"} />;
}
